import _extends from "@babel/runtime/helpers/extends";
import { COLOR } from "@xe/constants";
import { buttons, headings, icons, links, listItems, paragraphs } from "@xe/theme-config-common";
var blue2 = COLOR.blue2,
    blue4 = COLOR.blue4,
    white = COLOR.white;
var fluidContainer = {
  backgroundColor: blue2
};
var guilloche = {
  ballColor: white,
  color: blue4,
  opacity: 1
};
export default _extends({}, buttons.darkMode, headings.darkMode, icons.darkMode, links.darkMode, listItems.darkMode, paragraphs.darkMode, {
  fluidContainer: fluidContainer,
  guilloche: guilloche
});